/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachPhoneConfirmRequest
 */
export interface AttachPhoneConfirmRequest {
    /**
     * 
     */
    token: string;
    /**
     * 
     */
    phone: string;
    /**
     * 
     */
    code: string;
}

/**
 * Check if a given object implements the AttachPhoneConfirmRequest interface.
 */
export function instanceOfAttachPhoneConfirmRequest(value: object): value is AttachPhoneConfirmRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function AttachPhoneConfirmRequestFromJSON(json: any): AttachPhoneConfirmRequest {
    return AttachPhoneConfirmRequestFromJSONTyped(json, false);
}

export function AttachPhoneConfirmRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachPhoneConfirmRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'phone': json['phone'],
        'code': json['code'],
    };
}

export function AttachPhoneConfirmRequestToJSON(json: any): AttachPhoneConfirmRequest {
    return AttachPhoneConfirmRequestToJSONTyped(json, false);
}

export function AttachPhoneConfirmRequestToJSONTyped(value?: AttachPhoneConfirmRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'phone': value['phone'],
        'code': value['code'],
    };
}

